<app-data-set
	#dataSet
	[dataSource]="dataSource"
	[rowId]="rowId"
	firstColumnProperty="entityRelationship.childCompany.name"
	[enablePersistentSelection]="true"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="companyName"
				[defaultFilterLabel]="filterLabels.companyName"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div>
					<div class="filter-grid" [style.--columns]="3">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.companyName }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('companyName')"
									(ngModelChange)="dataSet.filter('companyName', filterLabels.companyName, $event)"
									data-automation-id="company-name-input"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.subAuthorize }}</mat-label>
								<mat-select
									[ngModel]="dataSet.filter('subAuthorize')"
									(ngModelChange)="dataSet.filter('subAuthorize', filterLabels.subAuthorize, $event, yesNoOptions)"
									data-automation-id="subauthorize-picker"
								>
									@for (option of yesNoOptions; track option) {
										<mat-option
											[value]="option.value"
											[attr.data-automation-id]="'subauthorize-option-' + option.label"
											>{{ option.label }}</mat-option
										>
									}
								</mat-select>
							</mat-form-field>
						</div>
						@if (!hasOnlyPDQDevices) {
							<div class="filter-item">
								<mat-form-field subscriptSizing="dynamic" appearance="outline">
									<mat-label>{{ filterLabels.allowCodeGeneration }}</mat-label>
									<mat-select
										[ngModel]="dataSet.filter('allowCodeGeneration')"
										(ngModelChange)="
											dataSet.filter('allowCodeGeneration', filterLabels.allowCodeGeneration, $event, yesNoOptions)
										"
										data-automation-id="allowCodeGeneration-picker"
									>
										@for (option of yesNoOptions; track option) {
											<mat-option
												[value]="option.value"
												[attr.data-automation-id]="'allowCodeGeneration-option-' + option.label"
												>{{ option.label }}</mat-option
											>
										}
									</mat-select>
								</mat-form-field>
							</div>
						}
					</div>
					<div class="filter-grid" [style.--columns]="2">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.activeDate }}</mat-label>
								<input
									matInput
									[matDatepicker]="activeDatePicker"
									[ngModel]="dataSet.filter('activeDate')"
									(ngModelChange)="dataSet.filter('activeDate', filterLabels.activeDate, $event)"
									data-automation-id="active-date-input"
								/>
								<mat-datepicker-toggle
									matSuffix
									class="date-picker-primary-blue"
									[for]="activeDatePicker"
									data-automation-id="active-date-toggle"
								></mat-datepicker-toggle>
								<mat-datepicker #activeDatePicker data-automation-id="active-date-datepicker"></mat-datepicker>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.source }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('source')"
									(ngModelChange)="dataSet.filter('source', filterLabels.source, $event)"
									data-automation-id="source-company-name-input"
								/>
							</mat-form-field>
						</div>
					</div>
				</div>
			</app-data-set-search>
		</div>

		@if (hasDeviceManagementSystemCapability) {
			<div *appActionGroup>
				<app-data-set-action-button
					label="Grant Access"
					i18n-label="@@companyAccess-grantAccess"
					[isDisabled]="loadingService.isLoading(getControlAssignmentsLoadingKey) || !finishedLoadingInitData"
					(click)="
						loadingService.isLoading(getControlAssignmentsLoadingKey) || !finishedLoadingInitData
							? null
							: onGrantAccessClicked()
					"
					data-automation-id="company-access-grant-access-button"
				>
				</app-data-set-action-button>
			</div>
		}

		@if (hasDeviceManagementSystemCapability) {
			<div *appSelectedActionGroup>
				<app-data-set-action-button
					[label]="editAccessLabel"
					(click)="onEditControlAssignmentsClicked()"
					data-automation-id="company-access-edit-duration-button"
				>
				</app-data-set-action-button>
			</div>
		}

		@if (hasDeviceManagementSystemCapability) {
			<div *appSelectedActionGroup>
				<app-data-set-action-button
					class="destructive"
					icon="clear_icon"
					label="Remove"
					i18n-label="@@companyAccess-remove"
					data-automation-id="company-access-delete-button"
					(click)="onDeleteControlAssignmentsClicked()"
				>
				</app-data-set-action-button>
			</div>
		}
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(getControlAssignmentsLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getControlAssignmentsLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="visibleColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="rowSelect">
					<th mat-header-cell *matHeaderCellDef>
						@if (hasDeviceManagementSystemCapability) {
							<mat-checkbox
								[checked]="isSelectedAllChecked()"
								[indeterminate]="isSelectAllIntermediate()"
								(change)="onSelectAllToggle($event.checked)"
								data-automation-id="delete-checkbox"
							></mat-checkbox>
						}
					</th>
					<td mat-cell *matCellDef="let row">
						@if (isSelectable(row)) {
							<app-data-set-table-row-selection
								[data]="row"
								[appHasSystemCapability]
								has="deviceManagement"
							></app-data-set-table-row-selection>
						}
					</td>
				</ng-container>
				<ng-container matColumnDef="companyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyAccess-company">Company</th>
					<td mat-cell *matCellDef="let row">{{ row.entityRelationship.childCompany.name }}</td>
				</ng-container>
				<ng-container matColumnDef="controlName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyAccess-control">Control</th>
					<td mat-cell *matCellDef="let row">
						@if (!hasOnlySpecialGrantAccessDevices) {
							<div>
								<div class="resulting-device-access-control-day-time">
									{{ row.deviceControl | deviceControlDays }}
								</div>
								@if (
									row.deviceControl.permissions.canOpenKeyDoor.value ||
									row.deviceControl.permissions.canReleaseHasp.value
								) {
									<mat-icon
										svgIcon="sl-open-key-door"
										class="capabilities-icon"
										matTooltip="{{ deviceAccessTooltip }}"
									></mat-icon>
								}
								@if (row.deviceControl.permissions.canInstallDevice.value) {
									<mat-icon
										svgIcon="sl-install-device"
										class="capabilities-icon"
										matTooltip="{{ installDeviceTooltip }}"
									></mat-icon>
								}
								@if (row.deviceControl.permissions.canRemoveDevice.value) {
									<mat-icon
										svgIcon="sl-remove-device"
										class="capabilities-icon"
										matTooltip="{{ removeDeviceTooltip }}"
									></mat-icon>
								}
								@if (row.allowCodeGeneration && isHaspCodeGenFeatureEnabled) {
									<mat-icon
										svgIcon="sl-generate-access-code"
										class="capabilities-icon"
										matTooltip="{{ accessCodeTooltip }}"
									></mat-icon>
								}
								@if (row.allowHaspCodeGeneration && isHaspCodeGenFeatureEnabled && !hasOnlyGen3WallMountDevices) {
									<mat-icon
										svgIcon="sl-generate-hasp-code"
										class="capabilities-icon"
										matTooltip="{{ haspCodeTooltip }}"
									></mat-icon>
								}
								@if (row.deviceControl.permissions.canArmDisarmAjaxAlarm.value) {
									<mat-icon
										svgIcon="sl-shield-checkmark"
										class="capabilities-icon"
										matTooltip="{{ armDisarmAlarmTooltip }}"
									></mat-icon>
								}
								@if (row.deviceControl.permissions.canOverrideAjaxAlarm.value) {
									<mat-icon
										svgIcon="sl-bell-crossed-out"
										class="capabilities-icon"
										matTooltip="{{ alarmOverrideTooltip }}"
									></mat-icon>
								}
							</div>
						}

						<!-- Senturian/PDQ, SentriVault, or mixed special-grant: hide Visit/Install/Remove/Hasp -->
						@if (hasOnlySpecialGrantAccessDevices) {
							<div class="pdq-capability-container">
								<div>{{ row.deviceControl | deviceControlDaysOnly }}</div>
								<div>{{ row.deviceControl | deviceControlHoursOnly }}</div>
								@if (row.allowCodeGeneration) {
									<mat-icon
										svgIcon="sl-generate-access-code"
										class="pdq-capability-icon"
										matTooltip="{{ accessCodeTooltip }}"
									></mat-icon>
								}
								@if (row.deviceControl.permissions.canArmDisarmAjaxAlarm.value) {
									<mat-icon
										svgIcon="sl-shield-checkmark"
										class="capabilities-icon"
										matTooltip="{{ armDisarmAlarmTooltip }}"
									></mat-icon>
								}
								@if (row.deviceControl.permissions.canOverrideAjaxAlarm.value) {
									<mat-icon
										svgIcon="sl-bell-crossed-out"
										class="capabilities-icon"
										matTooltip="{{ alarmOverrideTooltip }}"
									></mat-icon>
								}
							</div>
						}
					</td>
				</ng-container>
				<ng-container matColumnDef="deviceGroupName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyAccess-deviceGroups">Device Group</th>
					<td mat-cell *matCellDef="let row">
						<span class="device-group-chip">
							{{ row.deviceGroup.name }}
						</span>
					</td>
				</ng-container>
				<ng-container matColumnDef="subAuthorize">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyAccess-subAuthorize">Sub-Authorize</th>
					<td mat-cell *matCellDef="let row">
						@if (row.allowSubAuthorization) {
							<span i18n="@@companyAccess-subAuthorize-yes">Yes</span>
						}
						@if (!row.allowSubAuthorization) {
							<span i18n="@@companyAccess-subAuthorize-no">No</span>
						}
					</td>
				</ng-container>
				<ng-container matColumnDef="allowCodeGeneration">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyAccess-allowCodeGeneration">
						Allow Code Generation
					</th>
					<td mat-cell *matCellDef="let row">
						@if (row.allowCodeGeneration) {
							<span i18n="@@companyAccess-allowCodeGeneration-yes">Yes</span>
						}
						@if (!row.allowCodeGeneration) {
							<span i18n="@@companyAccess-allowCodeGeneration-no">No</span>
						}
					</td>
				</ng-container>
				<ng-container matColumnDef="duration">
					<!-- This is in the user's local timezone (not UTC) because UTC dates give incorrect user assumptions
              and we don't know the timezone to use if there are multiple timezones per device in device group -->
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyAccess-duration">Duration</th>
					<td mat-cell *matCellDef="let row">
						{{ row | controlAssignmentDuration: localizeInherited : localizeTo : localizeNone }}
					</td>
				</ng-container>
				<ng-container matColumnDef="status">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyAccess-status">Status</th>
					<td mat-cell *matCellDef="let row">
						@if (isActive(row)) {
							<span i18n="@@userAccessTab-status-active">Active</span>
						}
						@if (!isActive(row)) {
							<span i18n="@@userAccessTab-status-inactive">Inactive</span>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="source">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyAccess-source">Source</th>
					<td mat-cell *matCellDef="let row">
						<div class="source-container row-left spacing-8">
							@if (row.entityRelationship?.parentEntity?.name) {
								<mat-icon class="icon-device-group-inherited" svgIcon="sl-device-group-inherited"></mat-icon>
							}
							{{ row.entityRelationship?.parentEntity?.name ? row.entityRelationship.parentEntity.name : '' }}
						</div>
					</td>
				</ng-container>

				@if (hasDeviceManagementSystemCapability || hasUserRoleManagement) {
					<ng-container matColumnDef="rowMenu">
						<th mat-header-cell *matHeaderCellDef></th>
						<td mat-cell *matCellDef="let row">
							<!-- Rules for allowing users to edit/delete the accesses:
                  1. They are allowed if the user has the device management system capability
                  2. They are allowed if they are from the same company that created the access record
                  3. They are NOT allowed if looking at device group accesses from the DEVICE access page and not the DEVICE GROUP access page
                  If editing this, make sure the countTotalSelectableElements() and onSelectAllToggle() logic is modified as needed.
                  -->
							@if (hasDeviceManagementSystemCapability && isSelectable(row)) {
								<app-data-set-table-menu [menu]="menu" [row]="row"></app-data-set-table-menu>
							}
						</td>
					</ng-container>
				}

				<tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: visibleColumns"></tr>
			</table>

			<mat-menu #menu="matMenu">
				<ng-template matMenuContent let-row="row">
					<button
						mat-menu-item
						(click)="onRowMenuEditClicked(row)"
						class="row-menu-edit"
						data-automation-id="company-access-edit-duration-two-button"
					>
						{{ editAccessLabel }}
					</button>
					<button
						mat-menu-item
						(click)="onRowMenuDeleteClicked(row)"
						i18n="@@companyAccess-RemoveButton"
						data-automation-id="company-access-delete-two-button"
					>
						Remove
					</button>
				</ng-template>
			</mat-menu>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
